<app-page-frame frameTitle="Forum" titleIcon="bi-chat-heart" homeRoute="/discussion">
    <router-outlet></router-outlet>
</app-page-frame>
